var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChained(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_filled",
    d: "M35.8 7c-2.9-2.9-4.5-5.1-8.1-1.5l-6.2 6.2c-2.1 2.1-1.3 3.9-1.3 3.9l3.1-3.1s3.8-4.3 7.7-.8c3.5 3.5-.5 7.2-.5 7.2l-3.4 3.6s1.8.8 3.9-1.3l6.2-6.2c3.6-3.5 1.4-5.1-1.4-8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M15.3 27.5L27.7 15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_filled",
    d: "M7.2 35.5c2.9 2.9 4.5 5.1 8.1 1.5l6.2-6.2c2.1-2.1 1.3-3.9 1.3-3.9L19.6 30s-3.8 4.3-7.7.8c-3.5-3.5.5-7.2.5-7.2l3.4-3.6s-1.8-.8-3.9 1.3l-6.2 6.2c-3.6 3.5-1.4 5.1 1.5 8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M27.1 22.5s1.8.8 3.9-1.3l6.2-6.2c3.6-3.6 1.4-5.2-1.5-8.1-2.9-2.9-4.5-5.1-8.1-1.5l-6.2 6.2c-2.1 2.1-1.3 3.9-1.3 3.9M15.8 20s-1.8-.8-3.9 1.3l-6.2 6.2c-3.6 3.6-1.4 5.2 1.5 8.1s4.5 5.1 8.1 1.5l6.2-6.2c2.1-2.1 1.3-3.9 1.3-3.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChained);
export default __webpack_public_path__ + "static/media/chained.af937339cc85e2b132ade439fba75732.svg";
export { ForwardRef as ReactComponent };